import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { IArgumentMetadata } from './argument.atoms';
import { IPolicyCondition } from './policy.atoms';

export type GraphLayout = 'tidy-tree' | 'tidy-tree-horizontal' | 'step';

export interface PolicyGraphEdgeData {
    condition?: IPolicyCondition;
    arg_metadata: IArgumentMetadata;
    error?: string;
}

export interface IStatusReason {
    reason: string;
    description?: string;
    system?: string;
    missing_action?: string;
    missing_extractor?: string;
}

export interface INodeNotes {
    text?: string;
    status_reason?: IStatusReason;
}

export interface NodeData {
    error?: string;
    notes?: INodeNotes;

    [key: string]: any;
}

export const minimizedNodeIdsAtom = atom<Set<string>>(new Set<string>());

export const argumentsForPathState = atom<Record<number, { value: any; created_at: string }>>({});

export const datasetAnalysisFilterDecisionAtom = atom<string[]>([]);

export const datasetAnalysisFilterSimulatedDecisionAtom = atom<string[]>([]);

export const datasetAnalysisDrawerOpenAtom = atom<boolean>(false);

export const datasetAnalysisDrawerHeightAtom = atom<number>(285);

export const labelCoverageAtom = atom<Record<string, string>>({});

export const labelCohesionAtom = atom<Record<string, number>>({});

export const clusteringResultAtom = atomWithStorage<import('@tymely/types/dataset').AutoLabelingResponse | null>(
    'tymely-clustering-results',
    null,
);

export const multiSensitivityClusteringResultAtom = atomWithStorage<
    import('@tymely/types/dataset').MultiSensitivityAutoLabelingResponse | null
>('tymely-multi-sensitivity-clustering-results', null);

export type DatasetDrawerTabMode = 'labelling' | 'argument' | 'simulation' | 'live-view' | 'policy-builder';

export const datasetDrawerSelectedTabAtom = atom<number>(0);

export const datasetDrawerOpenAtom = atom<boolean>(false);

export const datasetDrawerWidthAtom = atom<number>(650);
